// Shared route -> title map, lifted out of DashboardPage.jsx's old
// getPageTitle() so both DashboardPage and the new TopBar/Breadcrumb can
// use the same source of truth.
export const PAGE_TITLES = {
  dashboard: 'Dashboard',
  'creator-dashboard': 'My Dashboard',
  creators: 'Creators',
  invites: 'Invite Codes',
  team: 'Team Management',
  revenue: 'Revenue',
  payroll: 'Staff Balances',
  payouts: 'Payouts',
  wallet: 'Wallet',
  'my-earnings': 'My Earnings',
  tasks: 'Tasks',
  content: 'Content Vault',
  'content-plan': 'Content Plan',
  'content-library': 'My Library',
  'video-studio': 'Video Studio',
  agents: 'AI Agents',
  'content-upload': 'Upload Content',
  sops: 'SOP Library',
  academy: 'Training',
  reports: 'Reports',
  shifts: 'Shift Schedules',
  'accounts-library': 'Accounts Library',
  'posting-library': 'Posting Library',
  'marketing-analytics': 'Marketing Analytics',
  'tracking-links': 'Tracking Links',
  sales: 'Live Sales',
  'remote-control': 'Remote Control',
  settings: 'Settings',
  notifications: 'Notifications',
  messages: 'Messages',
  announcements: 'Announcements',
};

// A few ids mean different things to different roles. `content` is the big one:
// it is the vault for staff and the content plan for a creator, so a single
// static title would leave the header disagreeing with the page under it.
const ROLE_TITLES = {
  creator: {
    content: 'Content Plan',
    tasks: 'Operations',
  },
  // The sidebar calls this "My Links" for a marketer, because theirs is the
  // only set they can see. A header disagreeing with the item you just clicked
  // is the small kind of wrong that makes a page feel like someone else's.
  marketer: {
    'tracking-links': 'My Links',
  },
};

export function getPageTitle(page, user) {
  return ROLE_TITLES[user?.role]?.[page] || PAGE_TITLES[page] || 'Dashboard';
}
